import type { Id } from '@e-socna/data-layer';

export const EMPTY_ID_ARRAY: readonly Id[] = Object.freeze([]);

export const EMPTY_ID = '' as Id;
